import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from './Link'
import withNoRoles from 'containers/Role/Hide/AnyGlobalRoles'
import withAllRoles from 'containers/Role/Show/AllGlobalRoles'
import { GLOBAL_ROLES, ROUTE_ROLES } from 'containers/Role/constants'

const RoleLink = withAllRoles(Link)
const NoRoleLink = withNoRoles(Link)

const AdminLink = (props) => {
  return (
    <RoleLink
      roles={[ROUTE_ROLES.DATA_MANAGER]}
      {...props}
    />
  )
}

const InternalLink = (props) => {
  return (
    <NoRoleLink
      roles={[GLOBAL_ROLES.CLIENT_ACCESS]}
      {...props}
    />
  )
}

export {
  AdminLink,
  InternalLink
}
